import s from './Policy.module.scss';
import SubHeader from '../../components/SubHeader/SubHeader';
import { Helmet } from 'react-helmet-async';
import 'bootstrap/dist/css/bootstrap.min.css';
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import titleImage from "../../assets/images/titleImage.png";
import React from "react";

// const breadcrumbs = [
//     { label: 'ホーム', link: '/' },
//     { label: '予約規定' },
// ];

const Policy = () => {
    const breadcrumbItems = [
        { name: 'ホーム ', link: '/' },
        { name: '予約規定'}
    ];
    return (
        <>
            <Helmet>
                <title>予約規定 | 初めての方へ</title>
                <meta name="description" content="予約規定 | 初めての方へ" />
            </Helmet>

            <div className={s.root}>
                {/*<SubHeader title="予約規定" breadcrumbs={breadcrumbs} />*/}
                <div className={"row mt-3"}>
                    <div className={"col-12"}>
                        <Breadcrumb items={breadcrumbItems}/>
                        <div className={s.titleContainer}>
                            <h2><img className={s.titleImage} src={titleImage}/>予約規定 | 初めての方へ</h2>
                        </div>
                    </div>
                </div>
                <div className="container py-5">

                    {/* Intro */}
                    <div className="card shadow-sm border-0 mb-4">
                        <div className="card-body p-4">
                            <h2 className="mb-3">ご予約前に必ずご確認ください</h2>

                            <p>最新の予約規定はこちらです。</p>
                            <p>ご返金の必要があると当社が判断した場合、現金またはクレジットカードへ返金となります。</p>

                            <div className="alert alert-warning mt-3">
                                <strong>重要：</strong>
                                為替変動による返金差額は補償しておりません。
                            </div>

                            <div className="alert alert-danger">
                                12月25日・1月1日はキャンセル換算時間に含みません。
                            </div>
                        </div>
                    </div>

                    {/* Contact */}
                    <div className="card shadow-sm border-0 mb-4">
                        <div className="card-body p-4">
                            <h3>緊急連絡先</h3>

                            <p>飛行機遅延・欠航の場合はすぐにご連絡ください。</p>

                            <div className="d-flex flex-wrap gap-3 mt-3">
                                <a
                                    href="tel:+61740412583"
                                    className="btn btn-primary"
                                >
                                    📞 電話する
                                </a>

                                <a
                                    href="https://line.me/R/ti/p/%40dii1064j"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="btn btn-success"
                                >
                                    LINEで連絡する
                                </a>
                            </div>
                        </div>
                    </div>

                    {/* Payment */}
                    <div className="card shadow-sm border-0 mb-4">
                        <div className="card-body p-4">
                            <h3>お支払い方法</h3>

                            <p>対応カード：</p>

                            <div className="d-flex gap-3 mb-3">
                                <img
                                    src="https://dev.mightyaussie.com/wp-content/uploads/2019/04/card-visa.png"
                                    alt="Visa"
                                    width="50"
                                />
                                <img
                                    src="https://dev.mightyaussie.com/wp-content/uploads/2019/04/card-master.png"
                                    alt="Master"
                                    width="50"
                                />
                                <img
                                    src="https://dev.mightyaussie.com/wp-content/uploads/2019/04/card-amex.png"
                                    alt="Amex"
                                    width="50"
                                />
                            </div>

                            <div className="alert alert-info">
                                現地払い可能なツアーもございます。
                            </div>
                        </div>
                    </div>

                    {/* Accordion */}
                    <div className="accordion" id="policyAccordion">

                        {/* Section 1 */}
                        <div className="accordion-item">
                            <h2 className="accordion-header">
                                <button
                                    className="accordion-button"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#cancel1"
                                >
                                    飛行機遅延・欠航時のキャンセル規定
                                </button>
                            </h2>

                            <div
                                id="cancel1"
                                className="accordion-collapse collapse show"
                            >
                                <div className="accordion-body">

                                    <h5>ジェイさんオリジナルツアー</h5>

                                    <ul>
                                        <li>48時間以上前：無料</li>
                                        <li>48時間以内：50%</li>
                                        <li>24時間以内：100%</li>
                                        <li>日程変更：$10〜</li>
                                    </ul>

                                    <h5>他社催行ツアー</h5>

                                    <ul>
                                        <li>72時間以上前：手数料$10</li>
                                        <li>48時間以内：50%</li>
                                        <li>24時間以内：100%</li>
                                    </ul>

                                </div>
                            </div>
                        </div>

                        {/* Section 2 */}
                        <div className="accordion-item">
                            <h2 className="accordion-header">
                                <button
                                    className="accordion-button collapsed"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#cancel2"
                                >
                                    通常キャンセル規定
                                </button>
                            </h2>

                            <div
                                id="cancel2"
                                className="accordion-collapse collapse"
                            >
                                <div className="accordion-body">

                                    <ul>
                                        <li>72時間以上前：無料</li>
                                        <li>72時間以内：25%</li>
                                        <li>48時間以内：50%</li>
                                        <li>24時間以内：100%</li>
                                    </ul>

                                </div>
                            </div>
                        </div>

                        {/* Section 3 */}
                        <div className="accordion-item">
                            <h2 className="accordion-header">
                                <button
                                    className="accordion-button collapsed"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#pricing"
                                >
                                    料金・為替について
                                </button>
                            </h2>

                            <div
                                id="pricing"
                                className="accordion-collapse collapse"
                            >
                                <div className="accordion-body">

                                    <p>
                                        Webサイトの円表示価格は参考価格です。
                                    </p>

                                    <div className="alert alert-warning">
                                        決済時の為替レートで金額が確定します。
                                    </div>

                                </div>
                            </div>
                        </div>

                        {/* Section 4 */}
                        <div className="accordion-item">
                            <h2 className="accordion-header">
                                <button
                                    className="accordion-button collapsed"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#responsibility"
                                >
                                    責任範囲・免責事項
                                </button>
                            </h2>

                            <div
                                id="responsibility"
                                className="accordion-collapse collapse"
                            >
                                <div className="accordion-body">

                                    <p>
                                        ツアー中の事故、盗難、第三者による損害について、
                                        当社は責任を負いかねます。
                                    </p>

                                    <p>
                                        必ず旅行保険への加入をおすすめします。
                                    </p>

                                </div>
                            </div>
                        </div>

                    </div>

                </div>
            </div>
        </>
    );
};

export default Policy;